import React, { useEffect, useState } from 'react';
import { styled, Theme } from '@material-ui/core/styles';

import MenuBar from './components/MenuBar/MenuBar';
import MobileTopMenuBar from './components/MobileTopMenuBar/MobileTopMenuBar';
import PreJoinScreens from './components/PreJoinScreens/PreJoinScreens';
import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
import RecordingNotifications from './components/RecordingNotifications/RecordingNotifications';
import Room from './components/Room/Room';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import useHeight from './hooks/useHeight/useHeight';
import useRoomState from './hooks/useRoomState/useRoomState';
import DailPad from './components/DailPad/DailPad';
import './Style.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'popper.js/dist/umd/popper.min.js';
import * as base64 from 'base64-js';
import { DecryptAndDestruct } from './utils/DecryptingModule';
import axios from 'axios';
// import sha256 from 'crypto-js/sha256';
// import hmacSHA512 from 'crypto-js/hmac-sha512';
// import Base64 from 'crypto-js/enc-base64';
import CryptoJS from 'crypto-js';
const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: '1fr auto',
});

const Main = styled('main')(({ theme }: { theme: Theme }) => ({
  overflow: 'hidden',
  paddingBottom: `${theme.footerHeight}px`, // Leave some space for the footer
  background: 'white',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`, // Leave some space for the mobile header and footer
  },
}));

export default function App() {
  const roomState = useRoomState();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const param = searchParams.get('');
  const history = useHistory();
  const encryptionKeyBase64 = 'T543oUJD9RzlE7YzlGesLpqCL988CV1Zavj7hvjpTQw=';
  const encryptedData =
    'vA7WxYg2uWTwARsbeeIq7r1WSUgH0us5nv1GhrOTMbqW3GxVDsp+/ZHIxws1Nri/THL4wxXu1eVZqP3ZFWYKSPSHX1XrLFk4hxc3diDE+ruvV/WJvecn1kaBKS16PWg7Y3T8TqRKlZp0NdF9oSq8GSfqpVcpeF7jRX72yvBqCok=';
  const [Decrypted, SetDecyptedData] = useState({
    RecordId: '',
    ContactName: '',
    ContactPhoneNumber: '',
    ProviderId: '',
    providerName: '',
    Type: '',
  });
  const DecryptFunction = async () => {
    const trimmedString = search.trim().replace(/^(\?|\s)+/, '');

    const attributes = await DecryptAndDestruct(trimmedString, encryptionKeyBase64);
    // SetDecyptedData({
    // RecordId: attributes.RecordId,
    // ContactName: attributes.ContactName,
    // ContactPhoneNumber: attributes.ContactPhoneNumber || '',
    // ProviderId: attributes.ProviderId,
    // });
    if (attributes.Type == 'Host') {
      // const TokenApi2 = async () => {
      // const data = {
      //   username: 'twilio_sf_integration@worldclinic.com.avfeature',
      //   password: 'D1g1d3nt@',
      //   grant_type: 'password',
      //   client_id: '3MVG9N35s_jHNF.EDAxbj4DvRsMroWLLEU6.39SRMZ3h9sZAgztFK2Sub_M0uDOy6gYC7t4Fn1g==',
      //   client_secret: 'F224812801E66ED1767D38A1ACC039C5D259E8D26CB1AAE6FA7C5B0BA7CB7090',
      // };
      await axios
        .get('https://avserver.jobsitecare.com/salesforce/token')
        .then(async response => {
          //console.log(response, 'tokena');
          const config = {
            headers: {
              Authorization: `Bearer ${response.data}`,
            },
          };
          try {
            const response = await axios.post(
              `https://jobsitecare.my.salesforce.com/services/apexrest/CallStatus`,
              {
                recordId: attributes.RecordId,
                status: 'In Progress',
                roomId: `${window.location.origin}/${search}`,
                roomName: `${attributes.ProviderId + attributes.RecordId}`,
              },
              config
            );
            //console.log(response);
          } catch (err) {
            //console.log(err, 'tokena');
          }
        })
        .catch(error => {
          //console.log(error);
          // handle the error
        });
    }
    // }
    //   const response = await axios.post(
    //     `https://jobsitecare--avfeature.sandbox.my.salesforce.com/services/data/v58.0/query/?q=SELECT+FirstName,LastName+FROM+User+WHERE+Id='0057h000005KO68'`,
    //     config
    //   );
    //   //console.log(response);
    // } catch (err) {
    //   //console.log(err);
    // }
    //console.log(Decrypted);
    history.replace(`/room/${attributes.ProviderId + attributes.RecordId}`, {
      state: {
        RecordId: attributes.RecordId,
        ContactName: attributes.ContactName,
        ContactPhoneNumber: attributes.ContactPhoneNumber,
        ProviderId: attributes.ProviderId,
        providerName: attributes.providerName,
        Type: attributes.Type,
      },
    });
  };
  // DecryptFunction()

  // Example usage

  // DecryptFunction()
  useEffect(() => {
    DecryptFunction();
  }, []);
  const [decryptedMessage, setDecryptedMessage] = useState<string | null>(null);
  // Here we would like the height of the main container to be the height of the viewport.
  // On some mobile browsers, 'height: 100vh' sets the height equal to that of the screen,
  // not the viewport. This looks bad when the mobile browsers location bar is open.
  // We will dynamically set the height with 'window.innerHeight', which means that this
  // will look good on mobile browsers even after the location bar opens or closes.
  const height = useHeight();

  return (
    <Container style={{ height }}>
      {roomState === 'disconnected' ? (
        <PreJoinScreens />
      ) : (
        <Main>
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </Main>
      )}
    </Container>
  );
}
